module.exports = __webpack_public_path__ + "img/milestone-completed.3fd07e17.svg";